<template>
	<search-list ref='sl' v-if="!inAdvOffer || where.time" apiPath="/channelMmpOffer/list" :where="where" :order="order" 
	notSearchAll :searchKeys="searchKeys"  >
	<el-row v-if="!inAdvOffer" type="flex">
		<mm-lc title="Period" >
			<mm-month-picker v-model="where.time" />
		</mm-lc>
		<mm-lc title="Adv">
			<mm-adv-select v-model="where.adv_id" multiple/>
		</mm-lc>
		<mm-lc title="Channel">
			<mm-channel-select v-model="where.channel_id" multiple />
		</mm-lc>
		<!-- <mm-lc title="Manager">
			<mm-users v-model="where.manager" multiple></mm-users>
		</mm-lc>
		<mm-lc title="Operator">
			<mm-users v-model="where.operator" multiple></mm-users>
		</mm-lc> -->
		<mm-lc title="Amount Status">
			<mm-offer-amount-status v-model="where.status" multiple isChannel />
		</mm-lc>
		<mm-lc title="Adv. status">
			<mm-summary-status v-model="where.adv_status" multiple/>
		</mm-lc>
		<mm-lc title="Channel status">
			<mm-summary-status v-model="where.channel_status" multiple/>
		</mm-lc>
		<mm-lc title="Auth Manager" v-show="is_show_auth">
			<mm-users v-model="where.auth_manager" multiple not_admin></mm-users>
		</mm-lc>
	</el-row>

	<div class="switch-select" slot="switchActions">
		<!-- <div class="switch-actions">
			<span>Group:&nbsp;&nbsp;</span>
            <el-switch v-model="where.is_group" />
		</div> -->
		<!-- <div class="switch-actions">
			<span>MMP Only:&nbsp;&nbsp;</span>
            <el-switch v-model="where.manual" :active-value="1" :inactive-value="null" />
		</div>
		<div class="switch-actions">
			<span>API Only:&nbsp;&nbsp;</span>
            <el-switch v-model="where.manual" :active-value="0" :inactive-value="null" />
		</div> -->
	</div>
	<template slot="customSearch">
		<mm-lc title="Pid">
			<mm-multi-input v-model.trim="where.pid"/>
		</mm-lc>
		<mm-lc title="Af Prt">
			<mm-multi-input v-model.trim="where.af_prt"/>
		</mm-lc>
	</template>
		<template slot="statusAction">
			<el-dropdown size="mini" trigger="click">
				<el-button :disabled="where.is_group" size="small" type="primary">
					<i class="el-icon-edit"></i>Change Status
				</el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item class="status-deducted" @click.native="changeStatus('deducted')">Switch to Deducted</el-dropdown-item>
					<el-dropdown-item @click.native="openAmountAndDeductDialog">Cost &amp; Rev Deducted</el-dropdown-item>
					<el-dropdown-item class="status-processing" @click.native="changeStatus('processing')">Switch to Processing</el-dropdown-item>
					<el-dropdown-item class="status-processing" @click.native="changeStatus('cover')">Switch to Cover</el-dropdown-item>
					<el-dropdown-item class="status-holdon" @click.native="changeStatus('hold on')">Switch to Hold On</el-dropdown-item>
					<el-dropdown-item class="status-confirm" @click.native="changeStatus('confirm')">Switch to Confirm</el-dropdown-item>
					<el-dropdown-item class="status-notrunning" @click.native="changeStatus('notrunning')">Switch to NotRunning</el-dropdown-item>
					<el-dropdown-item @click.native="()=>showSelectTime=true">Switch to Chargeback</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</template>
		<el-button slot="actions" type="success" class="el-icon-document-add" @click="showAddDialog = true"></el-button>
		<mm-table slot="dataTable" slot-scope="res" :res="res" @sort-change="sortChange" @selection-change="selectOffer" >
			<template slot-scope="etc">
			<el-table-column type="selection"></el-table-column>
			<el-table-column label="Time" prop="period" fixed />
			<el-table-column label="Channel Id" prop="channel_id" fixed />
			<el-table-column v-if="!where.is_group" label="Channel name" prop="channel_name" fixed>
				<mm-get-detail slot-scope="sp" :row_id="sp.row.channel_id" :row_name="sp.row.channel_name" :row_type="'channel'"/>
			</el-table-column>
			<el-table-column v-if="!where.is_group" label="Offer Id" width="125"  :renderHeader="etc.renderHeaderCopy" prop="offer_id" fixed >
				<span slot-scope="sp">
					<mm-get-detail v-if="!sp.row.manual" :row_name="sp.row.offer_id" :row_id="sp.row.offer_id" row_type="offer" />
					<mm-get-detail v-if="sp.row.manual" :row_name="sp.row.offer_id" :row_id="sp.row.offer_id+','+sp.row.period" row_type="mmp_offer" />
				</span>
			</el-table-column>
			<el-table-column v-if="!where.is_group" label="Adv Offer Id" prop="adv_offer_id" fixed />
			<el-table-column v-if="!where.is_group" label="Offer Name" prop="offer_name" width="110" fixed />
			<el-table-column prop="pid" label="Pid" fixed />
			<el-table-column label="Af Prt" prop="af_prt" width="105" fixed/>
			<el-table-column v-if="!where.is_group" label="Adv name" prop="adv_name" width="110" >
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv_name" :row_id="sp.row.adv_id" row_type="adv" />
			</el-table-column>
			<el-table-column v-if="!where.is_group" label="Operator" prop="operator" width="85" />
			<mm-summary-column label="Conv" prop="conv" width="120" :is_slot="true" sortable="custom" key="conv">
				<div slot-scope="is">
					<el-input v-if="is.sp.row.manual && isEdit(is.sp.row.id)" type="number" @mousewheel.native.prevent v-model="is.sp.row.conv" :disabled="!(mmpOfferInfo[is.sp.row.id] && mmpOfferInfo[is.sp.row.id].offer_id)" @blur="update(is.sp.row)" @input="changeConv($event, is.sp.row, 'conv')" :key="convKey"/>
					<span v-else>{{is.sp.row.conv}}</span>
				</div>
			</mm-summary-column>
			<mm-summary-column label="Offer Rev" width="150" prop="snt_offer_rev" :is_slot="true" sortable="custom">
                <div slot-scope="is">
                    <el-input v-if="is.sp.row.manual && isEdit(is.sp.row.id)" type="number" @mousewheel.native.prevent v-model="is.sp.row.snt_offer_rev" @blur="update(is.sp.row)" @input="change($event, is.sp.row.id, 'snt_offer_rev')"/>
                    <span v-else>{{is.sp.row.snt_offer_rev}}</span>
                </div>
			</mm-summary-column>
			<mm-summary-column label="Amount Rev" prop="amount_rev" width="135" :is_slot="true" sortable="custom">
                <div slot-scope="is">
                    <el-input v-if="isEdit(is.sp.row.id)" type="number" @mousewheel.native.prevent v-model="is.sp.row.amount_rev" @blur="update(is.sp.row)" @input="change($event, is.sp.row.id)"/>
                    <span v-if="!isEdit(is.sp.row.id)">{{is.sp.row.amount_rev}}</span>
                </div>
			</mm-summary-column>
			<mm-summary-column label="Sent Conv" prop="sent_conv" width="120" sortable="custom" :is_slot="true">
                <div slot-scope="is">
                    <el-input v-if="is.sp.row.manual && isEdit(is.sp.row.id)" type="number" @mousewheel.native.prevent v-model="is.sp.row.sent_conv" :disabled="!(mmpOfferInfo[is.sp.row.id] && mmpOfferInfo[is.sp.row.id].offer_id)" @blur="update(is.sp.row)" @input="changeConv($event, is.sp.row, 'sent_conv')" :key="convKey"/>
                    <span v-else>{{is.sp.row.sent_conv}}</span>
                </div>
			</mm-summary-column>
			<el-table-column label="Sent/Conv" width="120">
                <div slot-scope="sp">
                    <span>{{sp.row.sent_conv && sp.row.conv ? (sp.row.sent_conv/sp.row.conv*100).toFixed(2) + '%' : '0%' }}</span>
                </div>
			</el-table-column>
			<mm-summary-column label="Cost" prop="snt_cost" sortable="custom" :is_slot="true">
                <div slot-scope="is">
                    <el-input v-if="is.sp.row.manual && isEdit(is.sp.row.id)" type="number" @mousewheel.native.prevent v-model="is.sp.row.snt_cost" @blur="update(is.sp.row)" @input="change($event, is.sp.row.id, 'snt_cost')"/>
                    <span v-else>{{is.sp.row.snt_cost}}</span>
                </div>
			</mm-summary-column>
			<mm-summary-column label="Amount Cost" prop="amount_cost" width="140" :is_slot="true" sortable="custom">
                <div slot-scope="is">
                    <el-input type="number" v-if="isEdit(is.sp.row.id)" @mousewheel.native.prevent v-model="is.sp.row.amount_cost" @blur="update(is.sp.row)" @input="change($event, is.sp.row.id, 'amount_cost')"/>
                    <span v-if="!isEdit(is.sp.row.id)">{{is.sp.row.amount_cost}}</span>
                </div>
			</mm-summary-column>
			<el-table-column label="Status" fixed="right" width="180">
                <div slot-scope="sp">
                    <el-tooltip v-if="isEdit(sp.row.id)" class="item" effect="dark" :content="sp.row.chargeback" placement="left">
                        <el-dropdown>
                            <el-button size="small" :class="'status-'+sp.row.status">
                                    {{sp.row.status}}
                                <i class="el-icon-arrow-down" />
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="(obj, k) in status_arr" :key="k">
                                    <div :class="'status-'+obj.v" @click="updateStatus(sp.row, obj.v)">{{obj.label}}</div>
                                </el-dropdown-item>
                                <el-dropdown-item class='status-deducted'>
                                    <div class="status-chargeback" @click="selectChargeback(sp.row)">Chargeback</div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-tooltip>
                    <el-tooltip v-if="!isEdit(sp.row.id)" class="item" effect="dark" :content="sp.row.chargeback" placement="left">
                        <span :class="`status-${sp.row.status} status-${sp.row.display_status}`">{{sp.row.display_status || sp.row.status}}</span>
                    </el-tooltip>
                </div>
			</el-table-column>
			<el-table-column v-if="where.is_group" label="Adv. Status" fixed="right" width="180">
                    <span slot-scope="sp" :class="'status-'+sp.row.adv_status">{{sp.row.adv_status}}</span>
			</el-table-column>
			<el-table-column v-if="!where.is_group" label="Edit" fixed="right">
                <el-switch slot-scope="sp" v-model="rowEditMode[sp.row.id]" @change="rowEdit(sp.row)"></el-switch>
			</el-table-column>
			</template>
		</mm-table>
	<el-dialog :visible.sync="showSelectTime" width="30%">
		<span slot="title">Chargeback Time</span>
		<el-form class="">
			<el-form-item label="chargebackTime" required>
					<el-date-picker v-model="chargebackTime" type="month" placeholder="Select"/>
			</el-form-item>
			<el-form-item class="form-item">
				<el-button type="primary" @click="offerChargeback">Save</el-button>
			</el-form-item>
		</el-form>
	</el-dialog>
	<el-dialog :visible.sync="costAndDeductedVisible" width="80%">
		<el-form size="small" label-width="120px">
			<el-row>
				<el-col :span="6">
					<el-form-item label="Rev Ratio(%)" required>
						<el-input-number :min="0" v-model="revRatio" @change="revRatioChange" />
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="Cost Ratio(%)" required>
						<el-input-number :min="0" v-model="costRevRatio" @change="costRatioChange" />
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="to Deducted">
						<el-switch v-model="costRevStatusToDeducted" @change="costRevStatusChange"></el-switch>
					</el-form-item>
				</el-col>
			</el-row>
			<el-table :data="costRevList" :key="costRevTableKey">
				<el-table-column prop="adv_name" label="Adv Name" />
				<el-table-column prop="channel_name" label="Channel Name" />
				<el-table-column prop="offer_name" label="Offer Name" />
				<el-table-column prop="pid" label="Pid" />
				<el-table-column prop="snt_cost" label="Cost" />
				<el-table-column prop="amount_cost" label="Amount Cost" />
				<el-table-column prop="after_cost" label="Amount Cost(After)" />
				<el-table-column label="Offer Rev" prop="snt_offer_rev"/>
				<el-table-column prop="amount_rev" label="Amount Rev" />
				<el-table-column prop="after_rev" label="Amount Rev(After)" />
				<el-table-column prop="status" label="Status">
					<div slot-scope="sp">
						<el-tooltip class="item" effect="dark" :content="sp.row.chargeback" placement="left">
							<span :class="`status-${sp.row.status} status-${sp.row.display_status}`">{{sp.row.display_status || sp.row.status}}</span>
						</el-tooltip>
					</div>
				</el-table-column>
				<el-table-column prop="after_status" label="Status(After)">
					<div slot-scope="sp">
						<span :class="`status-${sp.row.after_status} status-${sp.row.after_status}`">{{sp.row.after_status}}</span>
					</div>
				</el-table-column>
			</el-table>
			<div style="text-align:right;padding-top:10px;">
				<el-button padd type="primary" @click="costRevRatioSave" size="small">Save</el-button>
			</div>
		</el-form>
	</el-dialog>

	<el-dialog :visible.sync="showAddDialog">
		<span slot="title">Add Channel mmp Offer</span>
		<el-form label-width="200px" :model="addForm" ref="addForm">
			<el-form-item label="MMP Offer Id" required prop="offer_id">
				<el-input v-model.trim="addForm.offer_id" style="width:300px"/>
			</el-form-item>
			<el-form-item label="Pid" required prop="pid">
				<el-input v-model.trim="addForm.pid" style="width:300px"/>
			</el-form-item>
			<el-form-item label="Channel" required prop="channel_id">
				<mm-channel-select v-model="addForm.channel_id" style="width:300px"/>
			</el-form-item>
			<el-form-item label="Time" required prop="time">
				<el-date-picker append-to-body v-model="addForm.time" type="month" value-format="yyyy-MM" style="width:300px"/>
			</el-form-item>
			<el-form-item class="form-item">
				<el-button type="primary" @click="addChannelOffer">Save</el-button>
			</el-form-item>
		</el-form>
	</el-dialog>
	</search-list>
</template>

<script>
export default {
	props:{
		inAdvOffer:Boolean,
		where:{
			type:Object,
			default(){return {}}
		}
	},
	data() {
		const searchKeys = {
			adv_offer_id: { label: "Adv Offer Id" },
			offer_id: { label: "Offer Id" },
			offer_name: { label: "Offer Name", fuzzy: true },
			package_id: { label: "Package Id", fuzzy: true },
			// pid: { label: "Pid", fuzzy: true },
		};
		const user_info = this.$utils.getCookies(['group_name']);
		const is_show_auth = (user_info.group_name === 'admin');
		return {
			searchKeys:this.inAdvOffer?undefined:searchKeys,
			order: [['amount_rev','desc']],
			offer_arr: [],
			status_arr: [
				{ v: 'deducted', label: 'Deducted' },
				{ v: 'processing', label: 'Processing' },
				{ v: 'cover', label: 'Cover' },
				{ v: 'hold on', label: 'Hold on' },
				{ v: 'confirm', label: 'Confirm' },
				{ v: 'notrunning', label: 'Not Running' },
			],
			showSelectTime: false,
			chargebackTime: '',
			single: false,
			update_row: {},
			rowEditMode: {},
			is_show_auth,
			deductedRatioVisible: false,
			dedList: [],
			deductedRatio: 100,
			dedTableKey: 1,
			amountPercentVisible: false,
			revList: [],
			revRatio: 100,
			revTableKey: 1,
			showAddDialog: false,
			addForm: {},
			costAndDeductedVisible: false,
			costRevList: [],
			costRevRatio: 100,
			costRevTableKey: 1,
			costRevStatusToDeducted: false,
			mmpOfferInfo: {},
			convKey: 0,
		};
	},
	methods: {
		async update(row){
			await this.$post('/channelMmpOffer/update',row);
		},
		async updateStatus(row, status) {
			row.status = status;
			if (status !== 'chargeback') {
				row.chargeback = '';
			}
			await this.$post('/channelMmpOffer/update', row);
		},
		async offerChargeback() {
			if (!this.chargebackTime) {
				this.$message({
					type: 'info',
					message: 'Revocation operation',
				});
				return;
			}
			const chargeback = this.$utils.date_format(this.chargebackTime, 'YYYY-MM');
			if (this.single) {
				this.update_row.chargeback = chargeback;
				await this.$post('/channelMmpOffer/update', this.update_row);
				this.single = false;
			} else {
				this.changeStatus('deducted', chargeback);
			}
			this.chargebackTime = '';
			this.showSelectTime = false;
		},
		selectChargeback(row) {
			row.status = 'chargeback';
			this.update_row = row;
			this.single = true;
			this.showSelectTime = true;
		},
		changeConv(v, row, key) {
			this.change(v, row.id, key);
			if (key == 'conv') {
				row.snt_offer_rev = Number((v * this.mmpOfferInfo[row.id].offer_price).toFixed(2));
				this.change(row.snt_offer_rev, row.id, 'snt_offer_rev');
			} else if (key == 'sent_conv') {
				const camp = this.mmpOfferInfo[row.id].camps && this.mmpOfferInfo[row.id].camps.find((camp) => {
					return camp.channel_id == row.channel_id;
				}) || null;
				const offer_price = camp && camp.offer_price || 0;
				row.snt_cost = Number((v * offer_price).toFixed(2));
				this.change(row.snt_cost, row.id, 'snt_cost');

				row.amount_cost = Number((v * offer_price).toFixed(2));
				this.change(row.amount_cost, row.id, 'amount_cost');

				row.amount_rev = Number((v * this.mmpOfferInfo[row.id].offer_price).toFixed(2));
				this.change(row.amount_rev, row.id, 'amount_rev');
			}
		},
		change(v, id, key = 'amount_rev') {
			const rows = this.$utils._.keyBy(this.$refs.sl.rows, 'id');
			let total = parseFloat(v) - parseFloat(rows[id][key]);
			for (const num in rows) {
				total += parseFloat(rows[num][key]);
			}
			this.$refs.sl.summary[key] = total.toFixed(2);

		},
		async refresh(){
			await this.$refs.sl.refresh();
		},
		async sortChange(column){
			const order = this.order;
			if(column.order == 'ascending'){
				order[0] = [column.prop, 'asc'];
			}else if(column.order == 'descending'){
				order[0] = [column.prop, 'desc']
			}else {
				order[0] = ['amount_rev', 'desc']
			}
			await this.$refs.sl.refresh();
		},
		selectOffer(offer_arr){
			this.offer_arr = offer_arr;
		},
		async changeStatus(status, chargeback = ''){
			if(this.offer_arr.length == 0){
				this.$message({
					type:'error',
					message:'Nothing Change'
				});
				return;
			}
			const ids = [];
			if (chargeback) {
				status = 'deducted';
			}
			for(const offer of this.offer_arr){
				ids.push(offer.id);
			}
			const result = await this.$post('/channelMmpOffer/updateAll', { status, chargeback, ids:ids });
			if(result){
				this.$refs.sl.refresh();
			}

		},
		isEdit(id) {
			if (!this.where.is_group && this.rowEditMode[id]) {
				return true;
			}
			return false;
		},
		deductedRatioChange() {
			this.dedList.forEach((row) => {
				row.after_cost = Number((row.snt_cost * this.deductedRatio / 100).toFixed(1));
			});
			this.dedTableKey++;
		},
		async deductedRatioSave() {
			const rows = this.dedList.map((row) => {
				return {
					id: row.id,
					amount_cost: row.after_cost,
					status: row.after_status,
				}
			})
			const result = await this.$post('/channelMmpOffer/updateDeducedList', { rows });
			if(result && result.length) {
				this.$message.success('Success');
				this.$refs.sl.refresh();
				this.deductedRatioVisible = false;
			}
		},
		async revRatioSave() {
			const rows = this.revList.map((row) => {
				return {
					id: row.id,
					amount_rev: row.after_rev,
				}
			})
			const result = await this.$post('/channelMmpOffer/updateDeducedList', { rows });
			if(result && result.length) {
				this.$message.success('Success');
				this.$refs.sl.refresh();
				this.amountPercentVisible = false;
			}
		},
		openAmountAndDeductDialog() {
			if(this.offer_arr.length == 0) {
				this.$message({
					type:'error',
					message:'Nothing Change'
				});
				return;
			}
			this.costRevList = JSON.parse(JSON.stringify(this.offer_arr));
			this.costRevList.forEach((row) => {
				row.after_rev = row.snt_offer_rev;
				row.after_cost = row.snt_cost;
				row.after_status = row.status;
			})
			this.costRevRatio = 100;
			this.revRatio = 100;
			this.costAndDeductedVisible = true;
		},
		costRatioChange() {
			this.costRevList.forEach((row) => {
				row.after_cost = Number((row.snt_cost * this.costRevRatio / 100).toFixed(1));
			});
			this.costRevTableKey++;
		},
		revRatioChange() {
			this.costRevList.forEach((row) => {
				row.after_rev = Number((row.snt_offer_rev * this.revRatio / 100).toFixed(1));
			});
			this.costRevTableKey++;
		},
		costRevStatusChange() {
			this.costRevList.forEach((row) => {
				if (this.costRevStatusToDeducted) {
					row.after_status = 'deducted';
				} else {
					row.after_status = row.status;
				}
			});
			this.costRevTableKey++;
		},
		async costRevRatioSave() {
			const rows = this.costRevList.map((row) => {
				return {
					id: row.id,
					amount_rev: row.after_rev,
					amount_cost: row.after_cost,
					status: row.after_status,
				}
			})
			const result = await this.$post('/channelMmpOffer/updateDeducedList', { rows });
			if(result && result.length) {
				this.$message.success('Success');
				this.$refs.sl.refresh();
				this.costAndDeductedVisible = false;
			}
		},
		async addChannelOffer() {
			await this.$validate(this.$refs.addForm);
			await this.$post('channelMmpOffer/create',this.addForm);
			await this.$refs.sl.refresh();
			this.showAddDialog = false;
		},
		async rowEdit(row) {
			if (row.manual && !this.mmpOfferInfo[row.id]) {
				const offer = await this.$post("/mmpOffer/detail", { offer_id: row.offer_id, offer_month: row.period });
				this.mmpOfferInfo[row.id] = offer;
				this.convKey++;
			}
		}
	}
};
</script>

<style scoped>
.bt-create {
  position: relative;
  right: 0px;
}

.switch-select {
	display: flex;
	align-items: center;
	padding-left: 20px;
	font-size: 13px;
}
.switch-actions {
	padding-right: 10px;
}
.switch-action {
	display: flex;
	justify-content: space-between;
	padding-bottom: 10px;
}
.switch-popover-button {
	background-color: #5976c0;
	color: #fff;
}
</style>
